import floorImage from "../assets/floor.png";

export class Floor {
  x: number;
  y: number;
  width: number;
  height: number;
  image: HTMLImageElement;

  constructor(x: number, y: number, width: number, height: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;

    this.image = new Image();
    this.image.src = floorImage;
  }

  draw(ctx: CanvasRenderingContext2D) {
    // ctx.fillStyle = "red";
    // ctx.fillRect(this.x, this.y, this.width, this.height);
    ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
  }
}
